<script setup>
defineProps({
    title: {
        type: String,
        required: true,
    },
});
</script>

<template>
    <!--
        The entry of the current section is semibold, which is wider. Both
        copies share one grid cell, so every entry is sized for the bold
        variant and the bar keeps the same layout on every page.
    -->
    <span class="grid">
        <span class="col-start-1 row-start-1">{{ title }}</span>

        <span
            class="col-start-1 row-start-1 invisible font-semibold"
            aria-hidden="true"
        >{{ title }}</span>
    </span>
</template>
